import { createRouteRef, createApiRef, createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createRoutableExtension } from '@backstage/core-plugin-api';

const OCTOPUS_DEPLOY_PROJECT_ID_ANNOTATION = "octopus.com/project-id";

const octopusDeployEntityContentRouteRef = createRouteRef({
  id: "octopus-deploy-entity-content"
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const octopusDeployApiRef = createApiRef({
  id: "plugin.octopusdeploy.service"
});
const DEFAULT_PROXY_PATH_BASE = "/octopus-deploy";
class OctopusDeployClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    __publicField(this, "proxyPathBase");
    var _a;
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.proxyPathBase = (_a = options.proxyPathBase) != null ? _a : DEFAULT_PROXY_PATH_BASE;
  }
  async getReleaseProgression(opts) {
    var _a;
    const url = await this.getApiUrl(opts);
    const response = await this.fetchApi.fetch(url);
    let responseJson;
    try {
      responseJson = await response.json();
    } catch (e) {
      responseJson = { releases: [] };
    }
    if (response.status !== 200) {
      throw new Error(
        `Error communicating with Octopus Deploy: ${((_a = responseJson == null ? void 0 : responseJson.error) == null ? void 0 : _a.title) || response.statusText}`
      );
    }
    return responseJson;
  }
  async getApiUrl(opts) {
    const proxyUrl = await this.discoveryApi.getBaseUrl("proxy");
    const queryParameters = new URLSearchParams({
      releaseHistoryCount: opts.releaseHistoryCount.toString()
    });
    if (opts.projectReference.spaceId !== void 0) {
      return `${proxyUrl}${this.proxyPathBase}/${encodeURIComponent(
        opts.projectReference.spaceId
      )}/projects/${encodeURIComponent(
        opts.projectReference.projectId
      )}/progression?${queryParameters}`;
    }
    return `${proxyUrl}${this.proxyPathBase}/projects/${encodeURIComponent(
      opts.projectReference.projectId
    )}/progression?${queryParameters}`;
  }
}

const isOctopusDeployAvailable = (entity) => {
  var _a;
  return Boolean((_a = entity.metadata.annotations) == null ? void 0 : _a[OCTOPUS_DEPLOY_PROJECT_ID_ANNOTATION]);
};
const octopusDeployPlugin = createPlugin({
  id: "octopus-deploy",
  apis: [
    createApiFactory({
      api: octopusDeployApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new OctopusDeployClient({ discoveryApi, fetchApi })
    })
  ]
});
const EntityOctopusDeployContent = octopusDeployPlugin.provide(
  createRoutableExtension({
    name: "EntityOctopusDeployContent",
    component: () => import('./esm/index-16a4aebb.esm.js').then(
      (m) => m.EntityPageOctopusDeploy
    ),
    mountPoint: octopusDeployEntityContentRouteRef
  })
);

export { EntityOctopusDeployContent, OCTOPUS_DEPLOY_PROJECT_ID_ANNOTATION, OctopusDeployClient, isOctopusDeployAvailable, octopusDeployApiRef, octopusDeployPlugin };
//# sourceMappingURL=index.esm.js.map
